export default __webpack_public_path__ + "f1c779dd8b50b6e00df04b490c4cf07f.webp";